import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-play-fields',
  templateUrl: './play-fields.component.html',
  styleUrls: ['./play-fields.component.scss']
})
export class PlayFieldsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
